import { render, staticRenderFns } from "./ProductSectionGridCat.vue?vue&type=template&id=0ab83ff8"
import script from "./ProductSectionGridCat.vue?vue&type=script&lang=js"
export * from "./ProductSectionGridCat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports